/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
const mixPanelDevToken = '3f6561342db0bdab7fbae2dd72d3290e';
const mixPanelProdToken = '2ac645b5f4e809d19976f02fe90725b3';
const isProduction = environment === 'production';
export const mixPanelToken = isProduction ? mixPanelProdToken : mixPanelDevToken;
